import { MOVES, ORDER, TierKey } from '../constants';

import { MovesEnum } from 'shared/constants/shared-enums';

export const findTierId = (move: MovesEnum, collection: TierKey) => {
  let index = ORDER.findIndex((tier) => tier === collection);
  let moveIndex = MOVES.findIndex((m) => m === move);
  return index * 3 + moveIndex + 1;
};

// Map Tiers enum id (1..21) -> TierKey for the SAME move
export function tierIdToTierKey(id: number | bigint | null | undefined): TierKey {
  if (id == null) return 'none';
  const n = Number(id);
  if (!Number.isFinite(n) || n < 1) return 'none';
  // groups of 3 per collection: 1..3 bronze, 4..6 silver, ..., 19..21 grandmaster
  const colIdx = Math.floor((n - 1) / 3);
  return ORDER[colIdx] ?? 'none';
}
